import React, { Component } from 'react';
import { PnkHtmlForm } from '../../../pnk-react/pnk-controls/pnk-html-form';
import PnkImage from '../../../pnk-react/pnk-ctrl/pnk-image'
//import DateTimePicker from 'react-datetime-picker';
//import $ from 'jquery';
//import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';


export default class EventForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false
        }
    }



    render() {

        return (
            <div>
                {/* <div class="form-back-link" onClick={() => this.props.HandleRouting('home')}>
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    <a>Back</a>
        </div>  */}
                <div class="add-organizer-form-main">
                    <div class="container-fluid">
                        <h3>{this.props.mystate.showButtonType}</h3>

                        <PnkHtmlForm id="frmEventEntry" submitbtn="btnEventEntry" onsubmit={this.props.SaveEventEntryData} on style={{ marginTop: '20px' }}>
                            <div className="edit-btn-div" style={{ display: this.props.mystate.showEditBtn }}>
                                <button type="button" variant="light" className="profile-entry-cancel-btn btn" onClick={() => this.props.ShowEditMode()}>Edit</button>
                                <button style={{marginLeft:'10px'}} type="button" variant="light" className="profile-entry-cancel-btn btn" onClick={() => this.props.DuplicateMode()}>Duplicate</button>
                             
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Session Name</label>
                                        <input type="text" class="form-control form2-control-ausi"
                                            id="txtEventName"
                                            name="txtEventName"
                                            placeholder="Session Name"
                                            pnkvalidate="forceentry"
                                            pnkvalue={this.props.editDataObj.txtEventName}
                                            value={this.props.mystate.txtEventName}
                                            onBlur={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Invalid Session Name" />
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">

                                        <label for="exampleFormControlInput1">Session Category</label>
                                        <select class="custom-select mr-sm-2 form2-control-ausi"
                                            id="ddlEventCategory"
                                            name="ddlEventCategory"
                                            //placeholder="Event Name"
                                            pnkvalidate="forceselect"
                                            pnkvalue={this.props.editDataObj.ddlEventCategory}
                                            value={this.props.mystate.ddlEventCategory}
                                            onChange={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Select Category" >
                                          
                                                    <option value=''>Select Category</option>
                                          


                                            {
                                                this.props.categorylist.length > 0 ?
                                                    this.props.categorylist.map((item, i) => (
                                                        item.status === 1 ?
                                                            <option value={item.category_name}>{item.category_name}</option>
                                                            : ''
                                                    ))
                                                    : ''}
                                        </select>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Session Language</label>
                                        <select class="custom-select mr-sm-2 form2-control-ausi"
                                            id="ddlEventLanguage"
                                            name="ddlEventLanguage"
                                            //placeholder="Event Name"
                                            pnkvalidate="forceselect"
                                            pnkvalue={this.props.editDataObj.ddlEventLanguage}
                                            value={this.props.mystate.ddlEventLanguage}
                                            onChange={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Select Language" >
                                            <option value=''>Select Language</option>
                                            <option value="English">English</option>
                                            <option value="Hindi">Hindi</option>
                                            <option value="Hinglish">Hinglish</option>

                                        </select>
                                    </div>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <label for="exampleFormControlInput1">Start Time</label>


                                    {/* <div className="col-sm-12 padding-right-0" style={{ paddingTop: '2px' }}> */}
                                    <input type="text"
                                        id="txtEventStartTime"
                                        name="txtEventStartTime"
                                        class="form-control form2-control-ausi"
                                        onClick={this.props.HandleEventInput}
                                        placeholder={this.props.editDataObj.txtEventStartTime}
                                        pnkvalue={this.props.editDataObj.txtEventStartTime}
                                        //value={this.props.mystate.txtEventStartTime}
                                        pnkvalidate='forceentry'
                                        pnkdisplayerrormsg='Please Click to set session start time'
                                        style={{ width: '100%' }}
                                    //  disabled={this.props.mystate.formModeActivity}
                                    //  disabled='disabled'
                                    />

                                    {/* </div> */}


                                    { /*<div class="form-group">
                                       
                                        <input type="text" class="form-control form2-control-ausi"
                                            id="txtEventStartTime"
                                            name="txtEventStartTime"
                                            placeholder="Start Time"
                                            pnkvalidate="forceentry"
                                            pnkvalue={this.props.editDataObj.txtEventStartTime}
                                            value={this.props.mystate.txtEventStartTime}
                                            onChange={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Invalid Start Time"

                                        />
                                    </div>  */}
                                </div>
                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Duration</label>
                                        <input type="text" class="form-control form2-control-ausi"
                                            id="txtEventDuration"
                                            name="txtEventDuration"
                                            placeholder="Duration (in minutes)"
                                            pnkvalidate="forceRnumber"
                                            pnkvalue={this.props.editDataObj.txtEventDuration}
                                            value={this.props.mystate.txtEventDuration}
                                            onBlur={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Invalid Duration" />
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                                    <div class="form-group kinship-event-file  kinship-img-file" id="kinship-img-file">
                                        <label for="exampleFormControlInput1">Session Image</label>
                                        <PnkImage class="form-control form2-control-ausi"
                                            id="fileEventImage"
                                            name="fileEventImage"

                                            destinationFolder="application/public/images/uploads/kinship/events"
                                            allowedTypeStr="png,jpg,jpeg,pdf"
                                            btnPreviewText="Upload Session Image"
                                            //  multiple="true"
                                            // limitFiles="1"

                                            pnkvalidate="forceentry"
                                            pnkvalue={this.props.editDataObj.fileEventImage}
                                       //     value={this.props.mystate.fileEventImage}
                                            previewImageSrc={this.props.editDataObj.fileEventImage}
                                            mode={this.props.mystate.mode}
                                            renderChild={this.props.mystate.renderChild}
                                            onChange={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Invalid Session Image"
                                            itemStyle="height:150px;text-align:center;" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">

                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Total Seats</label>
                                        <input type="text" class="form-control form2-control-ausi"
                                            id="txtEventSeats"
                                            name="txtEventSeats"
                                            placeholder="No. of Seats"
                                            pnkvalidate="forceRnumber"
                                            pnkvalue={this.props.editDataObj.txtEventSeats}
                                            value={this.props.mystate.txtEventSeats}
                                            onBlur={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Invalid Seats No." />
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Already Filled</label>
                                        <input type="text" class="form-control form2-control-ausi"
                                            id="txtEventAlreadyFilled"
                                            name="txtEventAlreadyFilled"
                                            placeholder="Already Filled Seats"
                                            pnkvalidate="forceRnumber"
                                            pnkvalue={this.props.editDataObj.txtEventAlreadyFilled}
                                            value={this.props.mystate.txtEventAlreadyFilled}
                                            onBlur={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Invalid Seats No." />
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Organizer Name</label>
                                        <select class="custom-select mr-sm-2 form2-control-ausi"
                                            id="ddlEventOrganizerName"
                                            name="ddlEventOrganizerName"
                                         //   placeholder="Event Name"
                                            pnkvalidate="forceselect"
                                            pnkvalue={this.props.editDataObj.ddlEventOrganizerName}
                                            value={this.props.mystate.ddlEventOrganizerName}
                                            onChange={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Select Organizer" >
                                            <option value=''>Select Organizer</option>
                                            {this.props.organizerlist.length > 0 ?
                                                this.props.organizerlist.map((item, i) => (
                                                    item.organizer_status === 1 || item.organizer_status === '1' ?
                                                        <option value={item._id}>{item.organizer_name}</option>
                                                        : ''
                                                ))
                                                : ''}
                                        </select>

                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Session Description</label>
                                        <textarea class="form-control form2-control-ausi"
                                            id="txtEventDescription"
                                            name="txtEventDescription" rows="3"
                                            placeholder="Session Description"
                                            pnkvalidate="forceentry"
                                            pnkvalue={this.props.editDataObj.txtEventDescription}
                                            value={this.props.mystate.txtEventDescription}
                                            onBlur={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Invalid Session Description" ></textarea>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Session Mode</label>
                                        <select class="custom-select mr-sm-2 form2-control-ausi"
                                            id="ddlEventMode"
                                            name="ddlEventMode"
                                            //placeholder="Event Name"
                                            pnkvalidate="forceselect"
                                            pnkvalue={this.props.editDataObj.ddlEventMode}
                                            value={this.props.mystate.ddlEventMode}
                                            onChange={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Select One" >
                                            <option value="online">Online</option>
                                            <option value="offline">Offline</option>
                                        </select>

                                    </div>

                                </div>

                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Recurring Session</label>
                                        <select class="custom-select mr-sm-2 form2-control-ausi"
                                            id="ddlEventRecurring"
                                            name="ddlEventRecurring"
                                            //placeholder="Event Name"
                                            pnkvalidate="forceselect"
                                            pnkvalue={this.props.editDataObj.ddlEventRecurring}
                                            value={this.props.mystate.ddlEventRecurring}
                                            onChange={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Select One" >
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                        </select>

                                    </div>

                                </div>
                            </div>

                            <div class="row">

                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Entry Mode</label>
                                        <select class="custom-select mr-sm-2 form2-control-ausi"
                                            id="ddlEventEntryMode"
                                            name="ddlEventEntryMode"
                                            //placeholder="Event Name"
                                            pnkvalidate="forceselect"
                                            pnkvalue={this.props.editDataObj.ddlEventEntryMode}
                                            value={this.props.mystate.ddlEventEntryMode}
                                            onChange={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Select Session Entry Mode" >
                                            <option value="Free">Free</option>
                                            <option value="Paid">Paid</option>
                                        </select>
                                    </div>
                                </div>

                                {this.props.mystate.ddlEventEntryMode === 'Paid' ?
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                                        <div class="row">
                                            <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                                                <div class="form-group">
                                                    <label for="exampleFormControlInput1">INR</label>
                                                    <input type="text" class="form-control form2-control-ausi"
                                                        id="txtEventPricingINR"
                                                        name="txtEventPricingINR"
                                                        placeholder="INR"
                                                        pnkvalidate="forceRnumber"
                                                        pnkvalue={this.props.editDataObj.txtEventPricingINR}
                                                        value={this.props.mystate.txtEventPricingINR}
                                                        onBlur={this.props.HandleEventInput}
                                                        pnkdisplayerrormsg="Invalid Price" />
                                                </div>

                                            </div>
                                            <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                                                <div class="form-group">
                                                    <label for="exampleFormControlInput1">USD</label>
                                                    <input type="text" class="form-control form2-control-ausi"
                                                        id="txtEventPricingUSD"
                                                        name="txtEventPricingUSD"
                                                        placeholder="USD"
                                                        pnkvalidate="forceRnumber"
                                                        pnkvalue={this.props.editDataObj.txtEventPricingUSD}
                                                        value={this.props.mystate.txtEventPricingUSD}
                                                        onBlur={this.props.HandleEventInput}
                                                        pnkdisplayerrormsg="Invalid Pricing" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : ''}
                                <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label for="exampleFormControlInput1">Session Status</label>
                                        <select class="custom-select mr-sm-2 form2-control-ausi"
                                            id="ddlEventStatus"
                                            name="ddlEventStatus"
                                            //placeholder="Event Name"
                                            pnkvalidate="forceselect"
                                            pnkvalue={this.props.editDataObj.ddlEventStatus}
                                            value={this.props.mystate.ddlEventStatus}
                                            onChange={this.props.HandleEventInput}
                                            pnkdisplayerrormsg="Select Status" >
                                            <option value="1">Active</option>
                                            <option value="0">In-Active</option>
                                            {
                                                this.props.mystate.mode === 'edit' ?
                                                <option value="2">Cancel</option>
                                                :''
                                            }
                                        </select>
                                    </div>
                                </div>
                                
                                
                            </div>
                            <button class="btn create-event-btn add-organizer-btn pnkvalidatesubmit"
                                id="btnEventEntry" name="save"
                                onClick={() => this.props.SaveEventEntryData} >
                                {this.props.mystate.showButtonType}</button>
                        </PnkHtmlForm>
                    </div>
                </div>
            </div>
        )
    }
}